export default __webpack_public_path__ + "static/media/plus.7c6527ec.svg";